import React from 'react';
import { ethers } from 'ethers';

const TeamStats = ({ totalTeam, teamBusiness }) => {
  // Format team business
  const formattedTeamBusiness = ethers.utils.formatUnits(teamBusiness || '0', 18);

  return (
    <div className="team-stats">
      <h2>Team Overview</h2>
      <div className="team-metrics">
        <div className="team-metric">
          <span className="metric-label">Total Team:  </span>
          <span className="metric-value">{totalTeam}</span>
        </div>
        <div className="team-metric">
          <span className="metric-label">Team Business:  </span>
          <span className="metric-value">{parseFloat(formattedTeamBusiness).toFixed(2)} USDT</span>
        </div>
      </div>
    </div>
  );
};

export default TeamStats;
